module.exports = __webpack_public_path__ + "media/images/landing_page/home_main_mobile-ff0bdc674313eb22c9db90039d94dbaa.webp";